import { evenRound } from '@/utils/misc'

class AkAgreement {
  id
  ak
  dateBegin
  dateEnd
  ts
  price
  comments

  getCode() {
    return `${this.ak}/${this.ts}`
  }

  static assign (json) {
    const akAgreement = Object.assign(new AkAgreement(), json)
    akAgreement.price && (akAgreement.price = evenRound(akAgreement.price, 2))
    return akAgreement
  }
}

export default AkAgreement



// WEBPACK FOOTER //
// ./src/models/dictionaries/akAgreement.js